module.exports = __webpack_public_path__ + "media/images/top-8-7e3f5ec44bc78d03b9d2981041a1e9ee.png";